import { Box } from '@mui/material';
import { Container, Heading } from '../atomic';

/**
 * Page header with green bar styling for Collaborate page
 *
 * @param {Object} props - Component props
 * @param {string} props.title - Page title text
 * @returns {JSX.Element} Collaborate page header component
 */
function CollaboratePageHeader({ title = 'Collaborate With Us' }) {
  return (
    <Box
      sx={{
        borderTop: '4px solid var(--color-primary)',
        borderBottom: '4px solid var(--color-primary)',
        backgroundColor:
          'color-mix(in srgb, var(--color-primary) 5%, transparent)',
        py: 4,
        mb: 6,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center' }}>
          <Heading
            variant="h1"
            sx={{
              color: 'text.primary',
              fontWeight: 600,
              fontSize: { xs: '2.5rem', md: '3rem' },
              fontFamily: '"Playfair Display", serif',
            }}
          >
            {title}
          </Heading>
        </Box>
      </Container>
    </Box>
  );
}

export default CollaboratePageHeader;
